module.exports = __webpack_public_path__ + "img/xiala1.4573375c.svg";